import React from "react";

export default class extends React.Component {


    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.valid = this.valid.bind(this);

        const {field, formData} = this.props;
        formData[field.name] = formData[field.name] || field.default;

        this.state = {
            valid: true
        }
    }

    handleChange(event) {
        const {field, config, formData} = this.props;
        formData[field.name] = event.target.value;
        this.valid();
        try {
            this.props.onChange()
        } catch (e) {

        }
    }

    valid() {
        const {field, config, formData} = this.props;

        if (!field.required) {
            return true
        }

        this.setState({
            valid: !!formData[field.name]
        })


    }

    render() {
        const {field, config,formData,id} = this.props;
        const {valid} = this.state;

        let title = field.title;
        if(title.substr(-1) == "*"){
            title = title.slice(0, -1)
        }
        if (field.required) {
            title = <span>{title} <span className='pubhub-smartsheet-form-required'>*</span></span>
        }

        return (
            <div
                className={"row pubhub-smartsheet-form-element pubhub-smartsheet-textarea " + (valid ?"": "has-danger")}
                key={field.id}>
                <div className="pubhub-smartsheet-label">
                    <label htmlFor={field.id} className="col-form-label">{title}</label>
                </div>
                <div className="pubhub-smartsheet-element" key={id}>
                    <small id={field.id + 'passwordHelpBlock'} className="form-text text-muted">
                        {field.helpText}
                    </small>
                    <textarea className="form-control"
                              rows={field.maxRows}
                              aria-describedby={field.id + 'passwordHelpBlock'}
                              id={field.id}
                              defaultValue={formData[field.name]}
                              onChange={this.handleChange}
                              onBlur={this.valid}
                              ke={id}
                    >
                    </textarea>

                </div>
            </div>

        )
    }
}
